import { render, staticRenderFns } from "./SwitchConfigView.vue?vue&type=template&id=7f002333"
import script from "./SwitchConfigView.vue?vue&type=script&lang=js"
export * from "./SwitchConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports